import React from 'react'
import { LineProps } from '../../types'
import { concatClassName } from '../../utils/helpers'
import './line-component.scss'

const Line = ({ variant, classes }: LineProps) => {
  return <div className={`line ${variant} ${concatClassName(classes)}`}></div>
}
export { Line }
